import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import { setSlotFieldBySession } from '../../../components/FormRadio/helpers';
import FormSelect from '../../../components/FormSelect/FormSelect';
import { FORM_SELECT_TYPES } from '../../../components/FormSelect/types';
import useUserProfile from '../../../hooks/useUserProfile';
import { vars } from '../../../reactive';
import { setFormPage } from '../../../reactive/actions';

const FormSelectRepetition = () => {
  const { t } = useTranslation();
  const type = FORM_SELECT_TYPES.REPETITION;
  const options = Array.from({ length: 12 }, (_, i) => ({ id: i + 1, name: `${i + 1} ${i === 0 ? t('week') : t('weeks')}` }));
  const { register, handleSubmit, reset } = useForm();
  const [getProfile, { loading: userProfileLoading }] = useUserProfile(true);

  const onSubmit = (data: Record<string, string>) => {
    setSlotFieldBySession({
      orderGroupIndex: 0,
      session: 0,
      repetition: { type: 'weekly', repeat: Number(data.repetition) }
    });
    if (vars.isLoggedIn()) {
      getProfile();
    } else {
      setFormPage(FORM_PAGES.CREATE_ACCOUNT_EMAIL);
    }
  };

  return <FormSelect type={type} formOptions={{ register, handleSubmit, reset }} onSubmit={onSubmit} options={options} loading={userProfileLoading} />;
};

export default FormSelectRepetition;
